module.exports = __webpack_public_path__ + "static/laura_1-2eab71f2da1a5718f794a8ba6471a2b5.jpg";